<script>
exports.HomeService = (api, handleError) => {
  const basePath = '/home'
  const adminPath = `/admin${basePath}`

  const GetUsefulLinks = async ({ path = '', cache = true }) => {
    try {
      const queryString = []
      if (path.trim().length) {
        path = path
          .trim()
          .split('/')
          .filter((itm) => itm.trim().length)
          .join('/')
        queryString.push(`path=${path}`)
      }
      if (!Boolean(cache)) {
        queryString.push('cache=false')
      }
      const query = queryString.length ? '?' + queryString.join('&') : ''

      return await api.get(`${basePath}/useful-links${query}`)
    } catch (error) {
      return handleError(error)
    }
  }

  const GetHomeResources = async () => {
    try {
      return await api.get(`${basePath}/resources`)
    } catch (error) {
      return handleError(error)
    }
  }

  const CreateHomeResource = async (data) => {
    try {
      return await api.post(`${adminPath}/resources`, data)
    } catch (error) {
      return handleError(error)
    }
  }

  const UpdateHomeResource = async (uid, data) => {
    try {
      return await api.put(`${adminPath}/resources/${uid}`, data)
    } catch (error) {
      return handleError(error)
    }
  }

  const GetDocsAndForms = (fileName = '') => {
    try {
      return api.get(`${basePath}/docs/${fileName}`, {
        responseType: 'arraybuffer'
      }).then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      })
    } catch (error) {
      return handleError(error)
    }
  }

  return {
    GetUsefulLinks,
    GetHomeResources,
    CreateHomeResource,
    UpdateHomeResource,
    GetDocsAndForms
  }
}
</script>
